import {
    BackendType,
    FrontendType,
    ObjectType,
    StarjackDate,
} from '@/models/general';
import { convertDateFromDateArray } from '@/utils/time';

export type CashDesk<T extends ObjectType = FrontendType> = {
    createdAt: StarjackDate<T>;
    id: string;
    liftOperatorId: string;
    username: string;
};

export type CashDeskWithCredentials = {
    password: string;
} & CashDesk;

export type CreateCashDeskBody = {
    liftOperatorId: string;
    password: string;
    username: string;
};

export const createEmptyCashDeskWithCredentials =
    (): CashDeskWithCredentials => ({
        createdAt: new Date(),
        id: '',
        liftOperatorId: '',
        username: '',
        password: '',
    });

export const convertCashDeskFromResponse = (
    cashDesk: CashDesk<BackendType>
): CashDesk => ({
    ...cashDesk,
    createdAt: convertDateFromDateArray(cashDesk.createdAt),
});
